import { parseLocaleNumber } from '@heraion/shared';

// Pure weight-stepper arithmetic, extracted out of SetRow's applyDelta so
// the signed-step + clamp + round + empty-on-zero rules are unit-testable
// apart from the row's onChange wiring. The signed `delta` is what lets
// the stepper's ± toggle subtract as well as add.

/**
 * Apply a signed weight delta to the current (string) value: parse it
 * locale-aware, treat empty/non-positive as 0, add the delta, clamp at
 * 0, round to 2 dp, and collapse an exact 0 back to an empty string.
 */
export function steppedWeight(currentWeight: string, delta: number): string {
  const current = parseLocaleNumber(currentWeight);
  const base = Number.isFinite(current) && current > 0 ? current : 0;
  const next = Math.max(0, base + delta);
  const rounded = Math.round(next * 100) / 100;
  return rounded === 0 ? '' : rounded.toString();
}
